// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p4-0";
export var leftAlign = "_p4-4";
export var listItem = "_p4-2";
export var listItemWrapper = "_p4-1";
export var operationText = "_p4-3";